import { useAds } from '@xing-com/crate-ads-native-ads';
import { AdTypes } from '@xing-com/crate-common-graphql-types';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { type JobRecommendationVisibleJob } from '@xing-com/crate-jobs-hooks';

import { Ad } from '../ad';
import type { JobResultOrAd } from '../helpers';
import { Result } from '../result';
import * as S from '../results.styles';

export type ListType = 'SEARCH' | 'EMPTY_STATE_SEARCH' | 'EMPTY_STATE_RECOS';

type Props = {
  items: (JobResultOrAd | JobRecommendationVisibleJob)[];
  type: ListType;
  urgentJobsHighlighted?: Set<number>;
};

export const ResultsList: React.FC<Props> = ({
  items,
  type,
  urgentJobsHighlighted,
}) => {
  const { isLoggedOut } = useLoginState();

  const { ads } = useAds({
    adCount: 1,
    adTypes: [AdTypes.VideoAd, AdTypes.WebsiteAd],
    channel: 'jobs_search_web',
    skipQuery: isLoggedOut,
  });
  const ad = ads.length > 0 && ads[0];

  return (
    <S.List>
      {items.map((item, position) => {
        if (item === 'Ad') {
          if (!ad) return null;

          return (
            <li key="ad">
              <Ad ad={ad} position={position} />
            </li>
          );
        }

        return (
          <Result
            index={position}
            key={`${item.trackingToken}:${position}`}
            item={item}
            type={type}
            isUrgent={urgentJobsHighlighted?.has(position)}
          />
        );
      })}
    </S.List>
  );
};
